const services =
[
    {
        title:"Free Delivery",
        tagline:`From All Orders Over 5000 Rupees`,
        image:"../images/service.png",
    },
    {
        title:"Rewards & Offers",
        tagline:"Save upto 30% off",
        image:"../images/service-02.png",
    },
    {
        title:"Customer Support 24/7",
        tagline:"Talk with Us",
        image:"../images/service-03.png",
    },
    {
        title:"Affordable Prices",
        tagline:"Get Factory Default Price",
        image:"../images/service-04.png",
    },
    {
        title:"Secure Payments",
        tagline:"100% Protected Payments",
        image:"../images/service-05.png",
    },
    {
        title:"No Card EMI's",
        tagline:"EMI'S on Every Deals",
        image:"../images/service-05.png",
    },
    

]

export default services;